import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { NavigationService } from '../../services/navigation.service';
import { ProgramaService } from '../../services/programa.service';

@Component({
  selector: 'app-programa-add',
  templateUrl: './programa-add.component.html',
  styleUrls: ['./programa-add.component.scss']
})
export class ProgramaAddComponent extends BaseFormComponent<ProjetoCadastro> implements OnInit, OnDestroy {
  actionLabel: string = 'Novo';
  usuarioList: Usuario[];
  orgaoList: any[];
  ativoList: any[] = [{ id: 0, label: 'Não' }, { id: 1, label: 'Sim' }];
  idOrgaoUsuario: number;
  idPrograma: number;
  programa: ProjetoCadastro;

  constructor(
    private myService: ProgramaService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private storage: StorageService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loading();
    this.usuarioList = this.activatedRoute.snapshot.data["listUsuario"];
    this.orgaoList = this.activatedRoute.snapshot.data["listOrgao"];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.idOrgaoUsuario = this.storage.getInfoUser()?.orgao_id;

    this.form = this.fb.group({
      id: [''],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      description: [''],
      agency_id: [this.idOrgaoUsuario, [Validators.required]],
      actived: [1],
      manager_cpf: [null],
      manager_adjunct_cpf: [null],
    });
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res: ProjetoCadastro) => {
            this.loaded();
            this.confirmation('Programa criado com sucesso!').subscribe(() => {
              this.navigation.replace(['projetos', 'programa', res.id]);
            })
          },
          error: (error) => {
            this.msgError(error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back(['projetos', 'programa']);
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }
}
